import { useMemo } from "react";
import { dailyMealsPath, mealsPath, MODEL_COMPLEX_PATH, SET_DAY_MENU_RANGE_PATH } from "../../functions/src/admin/paths";
import { orderDayDeadlineContextFromPricing, type OrderDayDeadlineContext } from "../../functions/src/common/orderDeadlines";
import type { ModelComplexity } from "../../functions/src/types";
import { currentCatering, currentDailyMeals } from "../api/firebase";
import { useDatabase, useDatabaseVal } from "../api/firebaseHooks";

/** School-wide inputs for shared order deadline rules (menu vs daily meals, set-day menu ranges). */
export function useOrderDayDeadlineContext(): OrderDayDeadlineContext | null {
    const [modelConstants] = useDatabaseVal<ModelComplexity>(MODEL_COMPLEX_PATH);
    const setDayMenuRangesSnap = useDatabase(SET_DAY_MENU_RANGE_PATH);
    const dailyMealsSnap = useDatabase(dailyMealsPath(currentDailyMeals));
    const mealsSnap = useDatabase(mealsPath(currentCatering));

    return useMemo((): OrderDayDeadlineContext | null => {
        if (!modelConstants) {
            return null;
        }
        return orderDayDeadlineContextFromPricing(modelConstants, {
            setDayMenuRangesRoot: setDayMenuRangesSnap?.val() as Record<string, unknown> | null | undefined,
            dailyMeals: dailyMealsSnap?.val(),
            meals: mealsSnap?.val(),
        });
    }, [modelConstants, setDayMenuRangesSnap, dailyMealsSnap, mealsSnap]);
}
